<template>
  <div ref="charts" style="width:100%;height:500px"></div>
</template>

<script>
  import echarts from "echarts";
  import { onMounted, ref } from "vue";
  export default {
    props: {
      statistics: {
        type: Object
      },
      title:{
        type:String
      }
    },
    setup(props) {
      const charts = ref();
      onMounted(() => {
        const chart = charts.value;
        if (chart) {
          var myChart = echarts.init(chart);
          const option = {
            tooltip: {trigger: 'axis'},
         
            xAxis: {
              type: "category",
              data:props.statistics.today,
              boundaryGap: false,     //坐标轴两边不留白
            },
            yAxis: {
              type: 'value'
            },
            series: [
              {
                name: props.title,
                data: props.statistics.total,
                type: 'line',
                symbolSize: 6, 
              }
            ],
          };
          myChart.setOption(option);
          window.addEventListener("resize", function () {
            myChart.resize();
          });
        }
        window.removeEventListener("resize", function () {
          myChart.resize();
        });
      });
      return {
        charts,
      };
    },
  };
</script>